export const INIT = 'INIT'
export const UPDATE = 'UPDATE'
export const SET_STATE = 'SET_STATE'